import { useCareplanContext } from "@/domains/careplan/contexts/use-careplan-context";
import { CareplanCartSubscriptionStatus } from "@/routes/_private/-components/cart/careplan-cart-subscription-status";

export const PausedSubscriptionCard = () => {
  const { subscription } = useCareplanContext();

  if (!subscription) {
    return null;
  }

  return (
    <CareplanCartSubscriptionStatus.Root
      className="flex flex-col gap-3"
      subscription={subscription}
    >
      <CareplanCartSubscriptionStatus.Title level={4}>
        Your subscription is paused
      </CareplanCartSubscriptionStatus.Title>
      <CareplanCartSubscriptionStatus.Description>
        Resume your subscription to continue receiving your careplan products.
      </CareplanCartSubscriptionStatus.Description>
    </CareplanCartSubscriptionStatus.Root>
  );
};
